import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const SettingsContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  site_title: "AutoPride Group — Пригон авто из Европы",
  logo_text: "AUTOPRIDE",
  hero_title: "Автомобили из Европы под ключ",
  hero_subtitle: "Профессиональный подбор, пригон и таможенное оформление автомобилей премиум-класса из Европы. Прозрачно, быстро, надёжно.",
  hero_cta_text: "Открыть конфигуратор",
  stats_clients: "500+",
  stats_cars: "1000+",
  stats_years: "15+",
  stats_reviews: "98%",
  stats_clients_label: "Клиентов",
  stats_cars_label: "Автомобилей",
  stats_years_label: "Лет опыта",
  stats_reviews_label: "Довольных клиентов",
  why_us_title: "Почему выбирают нас",
  why_us_1_title: "Юридическая чистота",
  why_us_1_desc: "Проверяем каждый автомобиль по всем базам Европы и России.",
  why_us_2_title: "Быстрые сроки",
  why_us_2_desc: "От заказа до получения — 2-4 недели.",
  why_us_3_title: "Гарантия качества",
  why_us_3_desc: "Независимая экспертиза состояния перед покупкой.",
  why_us_4_title: "Под ключ",
  why_us_4_desc: "Логистика, таможня, регистрация — мы берём всё на себя.",
  cta_title: "Готовы заказать автомобиль?",
  cta_subtitle: "Оставьте заявку через конфигуратор или свяжитесь с нашими менеджерами напрямую.",
  services_title: "Полный спектр услуг",
  services_subtitle: "Мы обеспечиваем полный цикл от подбора до регистрации вашего автомобиля.",
  portfolio_title: "Каталог автомобилей",
  portfolio_subtitle: "",
  reviews_title: "Отзывы наших клиентов",
  reviews_subtitle: "Реальные отзывы от тех, кто уже воспользовался нашими услугами.",
  about_title: "AutoPride Group",
  about_subtitle: "",
  about_text_1: "AutoPride Group — это команда профессионалов с более чем 15-летним опытом на рынке автоимпорта.",
  about_text_2: "За годы работы мы пригнали более 1000 автомобилей и помогли более чем 500 клиентам найти идеальный автомобиль.",
  about_text_3: "Мы работаем с проверенными поставщиками и дилерами в Германии, Франции, Нидерландах, Бельгии и других странах Европы.",
  about_values_title: "Наши ценности",
  about_value_1_title: "Прозрачность",
  about_value_1_desc: "Открытое ценообразование и честные консультации",
  about_value_2_title: "Профессионализм",
  about_value_2_desc: "Каждый этап контролируется экспертами",
  about_value_3_title: "Надёжность",
  about_value_3_desc: "Гарантия юридической чистоты каждого автомобиля",
  about_value_4_title: "Скорость",
  about_value_4_desc: "Оптимальные сроки доставки без компромиссов",
  contacts_title: "Наши менеджеры",
  contacts_subtitle: "Свяжитесь с нами любым удобным способом. Мы ответим в течение 15 минут.",
  configurator_title: "Подберём ваш автомобиль",
  configurator_subtitle: "Заполните форму — мы найдём ваш идеальный автомобиль.",
  footer_description: "Профессиональный подбор, пригон и таможенное оформление автомобилей из Европы.",
  footer_copyright: "AutoPride Group. Все права защищены.",
  blog_title: "Новости и статьи",
  contacts_phone: "",
  contacts_email: "",
  contacts_address: "",
  telegram_channel: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    axios.get(`${API}/settings`).then(r => {
      const data = r.data || {};
      const filtered = {};
      for (const [key, value] of Object.entries(data)) {
        if (value !== null && value !== undefined && value !== "" && key !== "_id") {
          filtered[key] = value;
        }
      }
      setSettings(prev => ({ ...prev, ...filtered }));
      if (filtered.site_title) document.title = filtered.site_title;
    }).catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
